











































































































































































import Vue from "vue";
import Api from "../../base/api.typings";
import Component from "vue-class-component";
import socioService from "./socio-service";
import * as val from "../../base/validations";
import empresaAtualService from '../../features/empresa-atual/empresa-atual-service';
import { VueMaskDirective } from 'v-mask';
Vue.directive('mask', VueMaskDirective);
import routerService from '../../base/router-service';
import { Prop } from 'vue-property-decorator';
import { obterDiaMesAnoFormatado } from "../../utils/utils";
import servicoService from '../servico/servico-service';
import env from '../../env/env';
import areaService from '../area-atual/area-service';
import chamadoService from '../chamado/chamado-service';

@Component
export default class SocioCadastrar extends Vue {
    @Prop() socioId: number;

    obterDiaMesAnoFormatado = obterDiaMesAnoFormatado;

    socio: Api.App.Server.Socio.InserirEditar.Command = null;

    chamado: Api.App.Server.Chamado.InserirChamadoAutomatico.Command = null;

    empresaAtual: string = null;

    linkPedirAlteracoes = '';

    areaAtual: string = null;

    somenteLeitura = false;

    async obterServicoAlterarDadosSocio() {
        let servicoId: any = await servicoService.obterServicoAlterarDadosSocioId({});
        this.linkPedirAlteracoes = `${env.appUrl}/chamado/registrar/${servicoId.servicoGrupoId}/${servicoId.id}`;
    }

    get carregando() {
        return !this.socio;
    }

    async obterParaEditar() {
        let socio = await socioService.obterParaEditar({ id: this.socioId });
        this.socio = socio;
        this.socio.empresaId = this.empresaAtual;

        this.socio.dataNascAbertura = await obterDiaMesAnoFormatado(this.socio.dataNascAbertura);
    }

    async carregar() {
        this.empresaAtual = await empresaAtualService.obterEmpresaAtualId();
        this.areaAtual = await areaService.obterAreaPadrao();

        if (this.areaAtual == 'usuario' && this.socioId != null) {
            this.somenteLeitura = true;
            this.obterServicoAlterarDadosSocio();
        }

        if (this.socioId) {
            this.obterParaEditar();
        } else {
            this.socio = {
                id: 0,
                empresaId: this.empresaAtual,
                nome: null,
                cpfCnpj: null,
                rgIe: null,
                dataNascAbertura: null,
                porcentagem: null,
                proLabore: null,
                pisPasep: null,
                nit: null,
                responsavelReceita: null
            }

            this.chamado = {
                empresaId: this.empresaAtual,
                assunto: "Novo sócio",
                servicoId: 73,
                funcionarioId: null,
            }
        }
    }

    created() {
        this.carregar();
    }

    async cancelar() {
        let cancelado = await this.$confirm.open({
            title: "Cancelar",
            message: "Deseja realmente cancelar a operação ?"
        });
        if (cancelado) {

            this.$snackbars.open({
                text: "Ação cancelada!",
                color: "success",
            })
            await routerService.goTo('socio-listar');
        }
    }

    async salvarSocio() {
        if (this.empresaAtual != null) {
            this.$action.processSubmit({
                action: async () => {
                    if (this.socioId) {
                        await socioService.editar(this.socio);
                    } else {
                        await socioService.inserir(this.socio);

                        let formData = new FormData();

                        formData.append("empresaId", this.chamado.empresaId);
                        formData.append("assunto", this.chamado.assunto);
                        formData.append("servicoId", this.chamado.servicoId.toString());
                        formData.append("funcionarioId", this.chamado.funcionarioId ? this.chamado.funcionarioId.toString() : '');

                        await chamadoService.inserirChamadoAutomatico(formData);
                    }

                    let mensagem = "Obrigado pelo preenchimento dos dados. Foi aberto um chamado para o contador que irá analisar os dados informados em um prazo de até 4 dias úteis." +
                        "Novas interações sobre este funcionário serão tratadas através deste chamado.";

                    this.$snackbars.open({
                        text: mensagem,
                        color: "success"
                    })

                    if (this.socioId) {
                        await routerService.goTo('socio-listar');
                    } else {
                        await routerService.goTo('socio-email');
                    }
                },
                form: this.$refs.form,
                rules: this.rules,
                showSnackbar: false
            });
        }
    }

    rules = {
        $summary: [] as any[],
        padrao: [],
        nome: [val.required, val.minLength(3), val.maxLength(60)],
        cpfCnpj: [val.required, val.minLength(14)],
        rgIe: [val.required, val.maxLength(20)],
        dataNascAbertura: [],
        porcentagem: [val.required, val.decimal],
        proLabore: [val.decimal],
        pisPasep: [val.maxLength(20)],
        nit: [val.maxLength(20)],
        responsavelReceita: [val.required, val.minLength(3), val.maxLength(60)],
    }
}
